module.exports = __webpack_public_path__ + "static/img/ic_menu4.330c72aa.png";